import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { CredentialService } from "../credential.service";

@Injectable({ providedIn: "root" })
export class DelegationSelectorGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly credentialService: CredentialService
  ) {}

  canActivate(): boolean | UrlTree {
    return this.credentialService.isSelectorSession() || this.router.parseUrl("/");
  }
}
